export const UPDATE_WHATSAPP_NOTIFICATION_REQUEST = "UPDATE_WHATSAPP_NOTIFICATION_REQUEST";
export const UPDATE_WHATSAPP_NOTIFICATION_SUCCESS = "UPDATE_WHATSAPP_NOTIFICATION_SUCCESS";
export const UPDATE_WHATSAPP_NOTIFICATION_FAILURE = "UPDATE_WHATSAPP_NOTIFICATION_FAILURE";
export const UPDATE_WHATSAPP_NOTIFICATION_RESET = "UPDATE_WHATSAPP_NOTIFICATION_RESET";
export const updateWhatsappNotificationDataRequest = (payload) => ({
    type: UPDATE_WHATSAPP_NOTIFICATION_REQUEST,
    payload,
});
export const updateWhatsappNotificationDataSuccess = (payload) => ({
    type: UPDATE_WHATSAPP_NOTIFICATION_SUCCESS,
    payload,
});
export const updateWhatsappNotificationDataFailure = (error) => ({
    type: UPDATE_WHATSAPP_NOTIFICATION_FAILURE,
    payload: error,
});
export const updateWhatsappNotificationDataReset = () => ({
    type: UPDATE_WHATSAPP_NOTIFICATION_RESET,
});
